<template>
  <div>
    <template v-if="!reviewDashboard() && !codingDashboard()">
      <h1 class="page-header">No Access</h1>
      You do not have access to the dashboard. Please contact HIA.
    </template>

    <template v-else>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <clientNavSelector></clientNavSelector>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/${currentClientId}/dashboard` }">Dashboard</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="top-margin">
        <el-row :gutter="10">
          <el-col :span="24" style="margin-bottom: 20px;">
            <el-alert type="success" title="The Coding and Review Dashboards have moved, please use the buttons below to access the new dashboards." />
          </el-col>
          <el-col :span="12">
            <router-link v-if="codingDashboard()" :to="`/${currentClientId}/dashboard/coding`">
              <el-card class="actionCard" shadow="always">
                <i class="mdi mdi-airplay" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>
                Coding Support Dashboard
              </el-card>
            </router-link>
          </el-col>
          <el-col :span="12">
            <router-link v-if="reviewDashboard()" :to="`/${currentClientId}/dashboard/review`">
              <el-card class="actionCard" shadow="always">
                <i class="mdi mdi-clipboard-check-outline" style="font-size: 16px; margin: 0px 5px 0px 0px; background: transparent;"></i>
                Coding Review Dashboard
              </el-card>
            </router-link>
          </el-col>
        </el-row>
      </div>
    </template>
  </div>
</template>

<script>
import HiaAuthorization from '@/mixins/hiaAuthorization'
import { mapState } from 'vuex'

export default {
  name: 'dashboard',
  mixins: [HiaAuthorization],
  computed: {
    ...mapState('user/', ['currentClientId'])
  }
}
</script>
